import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type PortalCustomer = {
  id: string;
  firstName: string;
  lastName: string | null;
  email: string | null;
  portalCanCreateTickets: boolean;
};

type PortalAuthState = {
  customer: PortalCustomer | null;
  token: string | null;
  isAuthenticated: boolean;
  setAuth: (customer: PortalCustomer, token: string) => void;
  clearAuth: () => void;
};

export const usePortalAuthStore = create<PortalAuthState>()(
  persist(
    (set) => ({
      customer: null,
      token: null,
      isAuthenticated: false,
      setAuth: (customer, token) => set({ customer, token, isAuthenticated: true }),
      clearAuth: () => set({ customer: null, token: null, isAuthenticated: false }),
    }),
    { name: 'fixflow-portal-auth' },
  ),
);
